import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Col, Row } from 'react-bootstrap';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import AdminForm from '../form/AdminForm';
import validationSchema from '../form/CreateAdminForm.schema';
import { createAdmin, searchAdmin } from '../AdminsActions';

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordRepeat: '',
  status: '',
  role: '',
};

function CreateAdminPage({ createAdmin }) {
  const handleSubmit = (values, { setSubmitting }) => {
    createAdmin(values);
    setSubmitting(false);
    searchAdmin();
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Admins', url: '/admins' },
    { id: 3, type: 'span', text: 'Add Admin' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Add Admin" />
      <Row>
        <Col md="12">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur
          >
            {({ values }) => <AdminForm title="Create a New Admin" values={values} />}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createAdmin, searchAdmin }, dispatch);

export default connect(null, mapDispatchToProps)(CreateAdminPage);
